import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validateEmail, validatePhoneNumberMaskedTextBox } from '../../validators/validator';

export const AssessmentScheduleMeetingFormModel: ISedmsFormModel = {
    assessmentsList: {
        name: 'assessmentsList',
        // required: true
    },
    evaluationSk: {
        name: 'evaluationSk',
    },
    evaluatorName: {
        name: 'evaluatorName',
    },
    evaluatorTitle: {
        name: 'evaluatorTitle',
    },
    evaluatorPhone: {
        name: 'evaluatorPhone',
        validators: [{validator: validatePhoneNumberMaskedTextBox(false)}]
    },
    evaluatorEmail: {
        name: 'evaluatorEmail',
        validators: [{validator: validateEmail(false)}]
    },
    requiredAttendees: {
        name: 'requiredAttendees',
    },
    optionalAttendees: {
        name: 'optionalAttendees',
    },
    meetingStreetAddress1: {
        name: 'meetingStreetAddress1',
        required: true
    },
    meetingFloorRoom: {
        name: 'meetingFloorRoom',
    },
    teamsMeeting: {
        name: 'teamsMeeting',
    },
    meetingDate: {
        name: 'meetingDate',
        required: true
    },
    meetingStartTime: {
        name: 'meetingStartTime',
        required: true
    },
    meetingEndTime: {
        name: 'meetingEndTime',
        required: true
    },
    additionalInfo: {
        name: 'additionalInfo',
    }

}